// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1-Jml","info":"Note_info__1tWHx","note":"Note_note__3KQEL","actions":"Note_actions__1HHLq"};